import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '25px',
    backgroundColor: '#FFFFFF',
    minWidth: '760px',
    minHeight: '400px',
    padding: '60px 40px 20px',
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: 10,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: 10,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const TopBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  margin: '-40px -20px 0',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const SectionContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
  border: '1px solid #D7D8DB',
  borderRadius: '12px',
  margin: '28px 0',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: '600',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  marginBottom: '20px',
  width: '100%',
  '& span': { color: theme.palette.primary.light },
}));

export const FileList = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  paddingLeft: 0,
  listStyleType: 'none',
  '& span': { color: theme.palette.secondary.main },
}));

export const FileContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  borderBottom: '1px solid #ccc',
  padding: '8px 0 8px 4px',
}));

export const FileNameTypography = styled(Typography)(({ theme }) => ({
  minWidth: '300px',
  display: 'flex',
  gap: '6px',
  alignContent: 'center',
  color: '#595959',
  font: '400 16px Montserrat',
  '& span': {
    color: theme.palette.secondary.main,
    fontSize: 20,
  },
}));

export const StyledIcon = styled(ButtonBase)(({ theme }) => ({
  span: {
    color: theme.palette.secondary.main,
    fontSize: 20,
    padding: '4px',
    borderRadius: '50%',
  },
}));

type AttachFileButtonProps = {
  component: string;
};

export const AttachFileButton = styled(Button)<AttachFileButtonProps>(
  ({ component, theme }) => ({
    component,
    width: '270px',
    margin: '0 8px 0 20px',
    color: '#FFFFFF',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      filter: 'opacity(50%)',
    },
  })
);

export const InputBox = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  marginTop: '8px',
}));

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '24px',
  marginTop: '24px',
  width: '100%',
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.secondary.main,
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  width: '220px',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  width: '220px',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));
